import { colors, devices, font } from '../../../config/theme'
import { flexStart } from '../../../utils/jss-utils'

const style = {}

style.base = {
  maxWidth: '100%',
  // borderTop: `1px solid ${colors.lighterGray}`,
  '&> div': {
    fontSize: '16px'
  }
}

style.base[devices.desktop] = {
  '& .twoButtons': {
    '& button': {
      width: '49% !important'
    }
  }
}

style.base[devices.mobile] = {
  '& .footnote': {
    width: '100%',
    color: '#C1C1C1 !important',
    fontSize: '12px !important'
  },
  '& .twoButtons': {
    '& button': {
      width: '50% !important'
    },
    // '& button:first-child': {
    //   borderRight: `solid 1px ${colors.white} !important`
    // },
    '& button:nth-child(2)': {
      borderLeft: `solid 2px ${colors.white} !important`
    }
  }
}

style.messageContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontWeight: font.weights.medium,
  fontSize: '15px'
}

style.upcomingVisit = {
  color: colors.blue,
  fontSize: '28px !important',
  lineHeight: '34px',
  width: '260px'
}

style.selectedTimeslot = {
  color: colors.blue,
  fontWeight: '500',
  fontSize: '28px'
}

style.selectedTimeslot[devices.mobile] = {
  fontSize: '24px'
}

style.warningBtn = {
  margin: '0 5px 0 10px'
}

style.price = {
  fontSize: '50px',
  fontWeight: '500',
  marginTop: '16px',
  marginBottom: '10px'
}

style.price[devices.mobile] = {
  marginBottom: '8px'
}

style.paymentDetails = {}
style.paymentDetails[devices.desktop] = {
  ...flexStart,
  '& div:first-child': {
    minWidth: '48%', // same margin and width as buttons,
    paddingRight: '140px'
  },
  margin: '50px 0 50px 0',
  // '& div': {
  //   marginRight: '15%'
  // }
  '& div:nth-child(2)': {
    minWidth: '50%',
    maxWidth: '50%'
  }
}

style.paymentDetails[devices.mobile] = {
  marginTop: '35px',
  marginBottom: '100px',
  '& div:first-child': {
    maxWidth: '275px'
  },
  '& div': {
    marginBottom: '15px'
  },
  '& h1': {
    width: '80%'
  }
}

style.buttonArea = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '10px'
}

style.buttonArea[devices.desktop] = {
  '& button': {
    height: '70px !important'
  }
}

style.buttonArea[devices.mobile] = {
  height: '60px',
  '& button': {
    maxWidth: '100% !important' // buttons have 1% margin
  }
}

export default style
